import { useAuth } from '@/contexts/AuthContext';
import { useLocationContext } from '@/contexts/LocationContext';

/**
 * Returns the effective locationId for data fetching.
 * Always resolves to a concrete location ID — never undefined when logged in.
 *
 * Rule: every user (including super_admin and location_admin with multiple
 * locations) always works within exactly one location at a time.
 * selectedLocationId is the explicitly chosen location; falls back to
 * primaryLocationId so data queries are always scoped to a single location.
 */
export function useLocationId(): string | undefined {
  const { user } = useAuth();
  const { selectedLocationId } = useLocationContext();

  if (!user) return undefined;

  // Always resolve to a concrete location — selectedLocationId when explicitly
  // chosen, primaryLocationId as fallback. This applies to all roles including
  // super_admin, ensuring no query ever runs without a location filter.
  return selectedLocationId || user.primaryLocationId;
}
